'use strict';

/* eslint max-lines-per-function: 0 */
/* eslint quote-props: 0 */

var tools = require('./tools'),
    ids = require('./ids'),
    links = require('./links'),

    enable = false,
    url;


module.exports = function ( data ) {
    var renders = links.api.renders,
        gettext = links.gettext,
        getter = links.api.getters.environment,
        saver = links.api.savers.environment,
        sections, content;

    sections = [
        {
            id: ids.multicast,
            name: gettext('Multicast proxy'),
            description: gettext('The multicast proxy function allows you to play rtp and udp streams'),
            icon: 'theme-icon-multicast',
            parent: ids.base
        }
    ];

    content = [
        {
            id: ids.multicastE + 1,
            name: gettext('Enable Multicast proxy'),
            description: gettext('Enable Multicast proxy function'),
            icon: '',
            render: renders.toggle,
            saveImmediate: true,
            environment: {
                'mc_proxy_enabled': false,
                'mc_proxy_url': ''
            },
            prepareForRender: function ( env, callback ) {
                enable = env['mc_proxy_enabled'];
                callback(enable);
            },
            prepareForSave: function ( value, callback ) {
                var index = 0;

                this.environment['mc_proxy_enabled'] = value;
                enable = value;
                url = this.environment['mc_proxy_url'];

                if ( stbPlayerManager && stbPlayerManager.list ) {
                    if ( enable && url ) {
                        for ( index; index < stbPlayerManager.list.length; index++ ) {
                            stbPlayerManager.list[index].multicastProxy = url;
                        }
                    } else {
                        for ( index; index < stbPlayerManager.list.length; index++ ) {
                            stbPlayerManager.list[index].multicastProxy = '';
                        }
                    }
                }
                gSTB.EnableMulticastProxy(value);
                callback();
            },
            getter: getter,
            saver: saver,
            parent: ids.multicast
        },
        {
            id: ids.multicastE + 2,
            name: gettext('Link to multicast proxy'),
            description: gettext('Enter a link to your home router / switch, on which UDP Proxy function is enabled'),
            icon: '',
            render: renders.input,
            saveImmediate: true,
            config: {
                title: gettext('Enter link to multicast proxy'),
                mode: 'qwerty'
            },
            advanced: true,
            environment: {
                'mc_proxy_url': ''
            },
            prepareForRender: function ( env, callback ) {
                this.config.value = env['mc_proxy_url'];
                callback(this.config.value);
            },
            prepareForSave: function ( value, callback ) {
                var error = true,
                    index = 0;

                if ( value === '' || tools.validateUrl(value) ) {
                    this.environment['mc_proxy_url'] = url = value;
                    gSTB.SetMulticastProxyURL(value);

                    if ( enable && stbPlayerManager && stbPlayerManager.list ) {
                        for ( index; index < stbPlayerManager.list.length; index++ ) {
                            stbPlayerManager.list[index].multicastProxy = url;
                        }
                    }
                    error = false;
                } else {
                    core.notify({
                        title: gettext('Link to multicast proxy must be url'),
                        icon: 'alert',
                        type: 'error'
                    });
                }

                callback(error);
            },
            getter: getter,
            saver: saver,
            parent: ids.multicast
        }
    ];

    sections.forEach( function ( item ) {
        data.sections.push(item);
    });

    content.forEach(function ( item ) {
        data.options.push(item);
    });
};
